<template>
  <div class="timetable">
    <div class="timetable-items row" v-if="Object.keys(item).length">
      <figure class="item col-md-4" v-for="(disciplines, week) in timetable" :key="week">
        <div class="timetable-item__wrapper">
          <div class="timetable-item__cap">
            {{week_titles[week-1]}}
          </div>
          <div class="timetable-item__list">
            <div class="timetable-item__list-wrapper" v-for="(item, key) in disciplines" :key="key">
              <div>
                <div class="timetable-item__title">{{item.discipline.title}}</div>
                <div class="timetable-item__name">{{item.customer.full_name}}</div>
              </div>
              <div class="time-content">
                <span>{{item.schedule.from_at | mmSecondToSecond}}</span> 
                  - 
                <span>{{item.schedule.till_at | mmSecondToSecond}}</span>
              </div>
            </div>
          </div>
        </div>
      </figure>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, errorNotify } from "@/plugins/functions";
export default {
  props: ["id"],
  data(){
    return {
      timetable: {},
      item: {},
      week_titles: [
        "Понедельник",
        "Вторник",
        "Среда",
        "Четверг",
        "Пятница",
        "Суббота",
        "Воскресенье",
      ]
    }
  },
  computed: {},
  components: {},
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
  },
  async created() {
    this.itemLink = `business/groups/${this.id}/timetables`;
    this.item = await this.cardContent(this.itemLink);
    this.item.timetable.forEach((e, i)=>{
      if(typeof this.timetable[e.week] == 'undefined')
        this.timetable[e.week] = []
      this.timetable[e.week].push(e)
    })
  },
  mounted(){},

};
</script>
<style>
</style>
